<template>
  <b-modal
      :visible="visible"
      id="admin-new-shipper-price-modal"
      ref="modal"
      title="Add new Shipper Price"
      hide-footer
      centered
  >
    <b-form @submit.prevent="submitForm">
      <b-form-group v-if="!shipperId" label="Shipper">
        <b-form-select
            v-model="formData.shipper"
            :options="shipperOptions"
            :state="fieldValid('shipper')"
        />
        <b-form-invalid-feedback :state="fieldValid('shipper')">
          {{ formValidation.shipper }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Destination State">
        <b-form-select
            v-model="formData.destination_state"
            :options="stateOptions"
            :state="fieldValid('destination_state')"
        />
        <b-form-invalid-feedback :state="fieldValid('destination_state')">
          {{ formValidation.destination_state }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Destination City">
        <b-form-input
            v-model.trim="formData.destination_city"
            type="text"
            name="city"
            :state="fieldValid('destination_city')"
        />
        <b-form-invalid-feedback :state="fieldValid('destination_city')">
          {{ formValidation.destination_city }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Shipping Price">
        <b-form-input
            v-model.trim="formData.price"
            type="number"
            step="any"
            min="0"
            autocomplete="off"
            :state="fieldValid('price')"
        />
        <b-form-invalid-feedback :state="fieldValid('price')">
          {{ formValidation.price }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button type="submit" variant="primary" :disabled="formState.processing">
        Save new Shipper Price
        <b-spinner v-if="formState.processing" class="ml-1" small></b-spinner>
      </b-button>
      <b-btn type="button" variant="secondary" @click.prevent="close">Cancel</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import {STATES_OPTIONS} from "../constants";
import {API_ROUTES} from "../api";

export default {
  name: "AdminShipperPriceNewModal",
  emits: ['created'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    shipperId: Number|String,
    shippers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      formData: {
        shipper: this.shipperId ?? "",
        destination_state: STATES_OPTIONS[0].value,
        destination_city: "",
        price: ""
      },
      formValidation: {},
      formState: {
        processing: false
      },
      stateOptions: STATES_OPTIONS
    }
  },
  computed: {
    shipperOptions() {
      return this.shippers.map(shipper => ({
        value: shipper.id,
        text: `${shipper.name} - ${shipper.license_number}`
      }));
    }
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'admin-new-shipper-price-modal');
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-new-shipper-price-modal');
    },
    set(field, value) {
      if (!value && field === 'destination_state') {
        this.formData['destination_state'] = STATES_OPTIONS[0].value;
      } else {
        this.formData[field] = value;
      }
    },
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    submitForm() {
      this.formState.processing = true;
      this.$api.post(API_ROUTES.ADMIN_SHIPPER_PRICES, this.formData).then(({data}) => {
        this.$bvToast.toast('Shipper price has been successfully created', {
          title: 'Success!',
          variant: 'success'
        });
        this.formValidation = {};
        this.$emit('created', data.shipper_price);
        this.formData = {
          shipper: this.shipperId ?? "",
          destination_state: STATES_OPTIONS[0].value,
          destination_city: "",
          price: ""
        };
      }).catch(({response: {data}}) => {
        this.$bvToast.toast(data.message ?? 'Failed to create a new shipper price', {
          title: 'Error!',
          variant: 'danger'
        });
        let validationErrors = {};
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in data.errors) {
            validationErrors[fieldName] = data.errors[fieldName].join(', ');
          }
        }
        this.formValidation = validationErrors;
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>